export default __webpack_public_path__ + "static/media/MikhailoGoriachii.660b48fe.jpg";